import { call, put, takeLatest } from 'redux-saga/effects' 
import { PATIENT_LIST_GET_API_CALL, PATIENT_LIST_RECEIVE_DATA_API, GET_ALL_MESSAGE_LIST, GET_ALL_API_MESSAGE_RECEIVED } from '../Actions/actionTypes'
import { patinetList, getAllChatMessage } from '../data/API'

 
function* hitPatientList(body){
    try{
        const response = yield call(patinetList, body.payload) 
        yield put({type:PATIENT_LIST_RECEIVE_DATA_API,  payload: response.data.patient_list}) 
    } catch (e){
        console.log(e)
    }
}

function* hitMessageList(body){
    try{
        const response = yield call(getAllChatMessage, body.payload) 
        yield put({type: GET_ALL_API_MESSAGE_RECEIVED,  payload: response.data.messages}) 
    } catch (e){
        console.log(e)
    }
}
 

export function* watchPatientSagasApi(action) {  
    yield takeLatest(PATIENT_LIST_GET_API_CALL, hitPatientList) 

    yield takeLatest(GET_ALL_MESSAGE_LIST, hitMessageList)  
}

 